import { Injectable } from '@angular/core';
import { UpdateEveUserPresentationGQL, UpdateEveUserPresentationMutation } from '../../generated/eveportal-api/graphql';
import { LogService } from './log.service';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { FetchResult } from '@apollo/client/core';

@Injectable({
  providedIn: 'root'
})
export class EveUserPresentationService {

constructor(
  private updateEveUserPresentationGQL: UpdateEveUserPresentationGQL,
  private logService: LogService
) {}
  /**
   * Update the selected presentation group and persist to server
   */
  updateSelectedPresentation(eveUserId: number, groupId: number): Observable<FetchResult<UpdateEveUserPresentationMutation>> {
    
    return this.updateEveUserPresentationGQL.mutate({
      eveUserId,
      presentationId: groupId
    }).pipe(
      tap((result) => {
        // Log successful update
        this.logService.logInfo(`Successfully updated presentation group to ${groupId} for user ${eveUserId}`);
      }),
      catchError((error) => {
        const errorMsg = `Failed to update presentation group to ${groupId} for user ${eveUserId}: ${error.message || error}`;
        this.logService.logError(errorMsg, error);
        return throwError(() => error);
      })
    );
  }
}
